'use client'

import { createContext, useContext } from 'react'

import { VideosFilterContextType } from './types'

export const VideosFilterContext = createContext<VideosFilterContextType | null>(null)

export const useVideosFilterContext = () => {
    const context = useContext(VideosFilterContext)
    if (!context) {
        throw new Error('useVideosFilterContext must be used within VideosFilterProvider')
    }
    return context
}
